import type * as React from 'react'
import style from './SettingsPageLayout.module.css'

export const DeprecatedSettingsPageLayout = ({
  children,
  wide = false,
}: {
  children: React.ReactNode
  wide?: boolean
}): JSX.Element => {
  return (
    <main className={style.wrapper}>
      <div className={wide ? style.innerWide : style.inner}>{children}</div>
    </main>
  )
}
